import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { OrderItemInvoice } from 'contracts/Orders';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_ORDER_ITEM_INVOICES_',
  }
);

export interface ListOrderItemInvoicesState {
  data: OrderItemInvoice[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListOrderItemInvoicesRequestAction {
  query?: Record<string, any>;
  onSuccess?: (data?: any) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: OrderItemInvoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListOrderItemInvoicesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListOrderItemInvoicesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListOrderItemInvoicesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListOrderItemInvoicesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListOrderItemInvoicesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listOrderItemInvoices = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListOrderItemInvoicesTypes = Types;
export const ListOrderItemInvoicesActions = Creators;
